/**
 * Список активных Следов с таймерами (§15, §10).
 */

import { formatDuration, type LocaleCode } from "@hive/i18n";
import { useTranslation } from "react-i18next";

import type { TraceView } from "../api/traces.js";

export interface TracesScreenProps {
  readonly locale: LocaleCode;
  readonly traces: readonly TraceView[];
  readonly loading?: boolean;
  readonly onClose: () => void;
  readonly onOpenHex?: (hexId: string) => void;
}

export function TracesScreen({
  locale,
  traces,
  loading = false,
  onClose,
  onOpenHex,
}: TracesScreenProps): React.JSX.Element {
  const { t } = useTranslation(["traces", "common"]);

  const qualityLabel = (quality: string): string =>
    t(`traces:quality.${quality}`, { defaultValue: quality });

  return (
    <section className="traces-screen" aria-label={t("traces:screen.title")}>
      <header className="traces-screen__head">
        <h2 className="traces-screen__title">{t("traces:screen.title")}</h2>
        <button type="button" className="button" onClick={onClose}>
          {t("common:action.close")}
        </button>
      </header>

      {loading ? (
        <p className="traces-screen__state">{t("common:state.loading")}</p>
      ) : traces.length === 0 ? (
        <p className="traces-screen__state">{t("traces:empty")}</p>
      ) : (
        <ol className="traces-screen__list">
          {traces.map((trace) => {
            const msLeft = Math.max(0, new Date(trace.expiresAt).getTime() - Date.now());
            return (
              <li key={trace.id} className="traces-item">
                <p className="traces-item__quality">{qualityLabel(trace.quality)}</p>
                <p className="traces-item__hex">{t("traces:hex", { hexId: trace.hexId })}</p>
                <p className="traces-item__expires">
                  {t("traces:expires", { duration: formatDuration(locale, msLeft) })}
                </p>
                {onOpenHex && (
                  <button
                    type="button"
                    className="button button--link"
                    onClick={() => onOpenHex(trace.hexId)}
                  >
                    {t("common:action.show_on_map")}
                  </button>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
}
